<script setup lang="ts">
defineProps<{ title: string }>()
const emit = defineEmits<{ close: [] }>()
</script>

<template>
  <div class="modal-backdrop" role="presentation" @click.self="emit('close')">
    <section class="modal-card" role="dialog" aria-modal="true" :aria-label="title">
      <div class="modal-heading">
        <h3>{{ title }}</h3>
        <button type="button" aria-label="关闭弹窗" @click="emit('close')">×</button>
      </div>
      <slot />
    </section>
  </div>
</template>
